export const NEWS: any[] = [
  // {
  //   "id": "1",
  //   "typeNews": "promotion",
  //   "picture": "./assets/images/promotion/01/1.jpg",
  //   "url": "http://takecarebeauty.com/TH/news/promotion-winter-2018.html",
  //   "href": true,
  //   "nameTH": "",
  //   "nameEN": "รวมโปรโมชั่น ต้อนรับหน้าหนาว ส่งท้ายปี 2018",
  //   "descriptionTH": "รวมโปรโมชั่น ต้อนรับหน้าหนาว ส่งท้ายปี 2018",
  //   "descriptionEN": "รวมโปรโมชั่น ต้อนรับหน้าหนาว ส่งท้ายปี 2018"
   
  // },
  // {
  //   "id": "1",
  //   "typeNews": "promotion",
  //   "picture": "./assets/images/promotion/p02.png",
  //   "url": "https://www.facebook.com/takecarebeautysalon/posts/1876889382367511",
  //   "href": true,
  //   "nameTH": "",
  //   "nameEN": "โปรโมชั่นสุด Hot จาก ProCare Eyelash",
  //   "descriptionTH": "โปรโมชั่นสุด Hot จาก ProCare Eyelash",
  //   "descriptionEN": "โปรโมชั่นสุด Hot จาก ProCare Eyelash"
   
  // },

  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/take_care_appreciates.jpg",
    "url": "http://takecarebeauty.com/EN/news/take_care_appreciates.html",
    "href": true,
    "nameTH": "",
    "nameEN": "บอกเลย! ขนาดแพทย์ยังวางใจเรื่องสุขลักษณะและบริการของ Take Care",
    "descriptionTH": "บอกเลย! ขนาดแพทย์ยังวางใจเรื่องสุขลักษณะและบริการของ Take Care",
    "descriptionEN": "บอกเลย! ขนาดแพทย์ยังวางใจเรื่องสุขลักษณะและบริการของ Take Care"   
  },


  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/xmas_final.jpg",
    "url": "http://takecarebeauty.com/EN/news/xmas_final.html",
    "href": true,
    "nameTH": "",
    "nameEN": "Gift Box แจกสำหรับโปรโมชั่นต่อขนตา",
    "descriptionTH": "Gift Box แจกสำหรับโปรโมชั่นต่อขนตา",
    "descriptionEN": "Gift Box แจกสำหรับโปรโมชั่นต่อขนตา"   
  },

  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/3design.jpg",
    "url": "http://takecarebeauty.com/EN/news/3design.html",
    "href": true,
    "nameTH": "",
    "nameEN": "3 new designs for procare lash volume",
    "descriptionTH": "3 new designs for procare lash volume",
    "descriptionEN": "3 new designs for procare lash volume"   
  },

  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/cirepil_wax.jpg",
    "url": "http://takecarebeauty.com/EN/news/cirepil_wax.html",
    "href": true,
    "nameTH": "",
    "nameEN": "ขาสวย สะกดอยู่ทุกสายตา!",
    "descriptionTH": "ขาสวย สะกดอยู่ทุกสายตา!",
    "descriptionEN": "ขาสวย สะกดอยู่ทุกสายตา!"   
  },


  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/vibrant.jpg",
    "url": "#",
    "href": true,
    "nameTH": "",
    "nameEN": "Vibrant Marble Design",
    "descriptionTH": "Vibrant Marble Design",
    "descriptionEN": "Vibrant Marble Design"
   
  },
  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/classique.jpg",
    "url": "#",
    "href": true,
    "nameTH": "",
    "nameEN": "Classique Marble Design",
    "descriptionTH": "Classique Marble Design",
    "descriptionEN": "Classique Marble Design"
   
  },
  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/redc.jpg",
    "url": "#",
    "href": true,
    "nameTH": "",
    "nameEN": "Red Carpet Design",
    "descriptionTH": "Red Carpet Design",
    "descriptionEN": "Red Carpet Design"
   
  },
  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/nailnewyear/nailnewyear_01.jpg",
    "url": "#",
    "href": true,
    "nameTH": "",
    "nameEN": "สวยรับปีใหม่ กับ Nail Design สุดหรู",
    "descriptionTH": "สวยรับปีใหม่ กับ Nail Design สุดหรู",
    "descriptionEN": "สวยรับปีใหม่ กับ Nail Design สุดหรู"   
  },
  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/merry/merry_01.png",
    "url": "#",
    "href": true,
    "nameTH": "",
    "nameEN": "Merry Christmas",
    "descriptionTH": "Merry Christmas",
    "descriptionEN": "Merry Christmas"   
  },

  
  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/03/00.png",
    "url": "http://takecarebeauty.com/EN/news/take-care-x-club-21-workshop.html",
    "href": true,
    "nameTH": "",
    "nameEN": "Take Care x Club 21 Mini Care Workshop",
    "descriptionTH": "Take Care x Club 21 Mini Care Workshop",
    "descriptionEN": "Take Care x Club 21 Mini Care Workshop"
   
  },
  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/04/00.png",
    "url": "http://takecarebeauty.com/EN/news/radiant-detox-program.html",
    "href": true,
    "nameTH": "",
    "nameEN": "Radiant & Detox Programmes by Ella Bache Workshop",
    "descriptionTH": "Radiant & Detox Programmes by Ella Bache Workshop",
    "descriptionEN": "Radiant & Detox Programmes by Ella Bache Workshop"
   
  },



  {
    "id": "1",
    "typeNews": "news",
    "picture": "./assets/images/news/01/01.jpg",
    "url": "/news/L-Oreal-XTENSO-OLEOSHAPE.html",
    "nameTH": "",
    "href": false,
    "nameEN": "L’Oréal “XTENSO OLEOSHAPE” Hair Shaping Exclusive Event at Zen Event Gallery",
    "createDate": "4 July 2018",
    "descriptionTH": "งานเปิดตัว “XTENSO OLEOSHAPE HAIR SHAPING” ณ Zen อีเว้นท์ แกลอรี่ เซ็นทรัลเวิล์ด ...",
    "descriptionEN": "L’Oréal “XTENSO OLEOSHAPE” Hair Shaping Exclusive Event at Zen Event Gallery ..."
   
  },  

  {
      "id": "1",
      "typeNews": "news",
      "picture": "./assets/images/news/01.jpg",
      "url": "#",
      "href": false,
      "nameTH": "",
      "nameEN": "การประดับเพชรจาก WAROVSKI และ ACCESSORIES",
      "createDate": "2 Jun 2018",
      "descriptionTH": "วันนี้เอาแบบเล็บที่มีความอลังการ มีการประดับเพชรจาก SWAROVSKI และ ACCESSORIES ต่างๆ ...",
      "descriptionEN": "วันนี้เอาแบบเล็บที่มีความอลังการ มีการประดับเพชรจาก SWAROVSKI และ ACCESSORIES ต่างๆ ..."
     
    },
    {
      "id": "2",
      "typeNews": "news",
      "picture": "./assets/images/news/02.jpg",
      "url": "#",
      "href": false,
      "nameTH": "ไอเดียทำผมไปปาร์ตี้คืนนี้ แบบสาวสาย ฝ.",
      "nameEN": "ไอเดียทำผมไปปาร์ตี้คืนนี้ แบบสาวสาย ฝ.",
      "createDate": "31 May 2018",
      "descriptionTH": "ไอเดียทำผมไปปาร์ตี้คืนนี้ แบบสาวสาย ฝ. ทั้งปังทั้งเกิดค่าา...^^ วันนี้เรามีแบบทรงผมมาเป็นไอเดียไว้สำหรับทำ ...",
      "descriptionEN": "ไอเดียทำผมไปปาร์ตี้คืนนี้ แบบสาวสาย ฝ. ทั้งปังทั้งเกิดค่าา...^^ วันนี้เรามีแบบทรงผมมาเป็นไอเดียไว้สำหรับทำ ..."
    },
    // {
    //   "id": "0",
    //   "typeNews": "promotion",
    //   "picture": "./assets/images/news/kbank_pro.jpg",
    //   "url": "#",
    //   "href": false,
    //   "nameTH": "",
    //   "nameEN": "KBank Wisdom รับเอกสิทธิ์ส่วนลด 15% ที่ร้านTake Care",
    //   "createDate": "2 Jun 2018",
    //   "descriptionTH": "แคปเปญดีๆที่ทางร้านTake Care ร่วมมือกับทางธนาคารกสิกรไทย มอบให้สำหรับลูกค้าที่ถือบัตรของทางKBank Wisdom รับเอกสิทธิ์ส่วนลด 15% ที่ร้านTake Care สาขา The Emquatier และ สาขา Paragon เท่านั้นนะค่ะ",
    //   "descriptionEN": "แคปเปญดีๆที่ทางร้านTake Care ร่วมมือกับทางธนาคารกสิกรไทย มอบให้สำหรับลูกค้าที่ถือบัตรของทางKBank Wisdom รับเอกสิทธิ์ส่วนลด 15% ที่ร้านTake Care สาขา The Emquatier และ สาขา Paragon เท่านั้นนะค่ะ"
     
    // },
    
  ]


// WEBPACK FOOTER //
// ./src/app/mokup/news.ts